import React from 'react';

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Terjadi error pada halaman.',
    };
  }

  componentDidCatch(error, info) {
    const context = String(this.props.resetKey || 'unknown-page');
    // eslint-disable-next-line no-console
    console.error(`[PageErrorBoundary:${context}]`, error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, errorMessage: '' });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const context = String(this.props.resetKey || 'unknown-page');
      return (
        <div className="m-4 rounded-xl border border-red-300 bg-red-50 p-6 text-red-900">
          <p className="text-base font-semibold">Halaman mengalami error.</p>
          <p className="mt-1 text-xs font-medium uppercase tracking-[0.12em] text-red-700/80">
            Context: {context}
          </p>
          <p className="mt-2 text-sm">
            {this.state.errorMessage || 'Silakan muat ulang halaman untuk mencoba kembali.'}
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-4 rounded-md border border-red-300 bg-white px-3 py-1.5 text-sm font-semibold text-red-700 hover:bg-red-100"
          >
            Muat Ulang Halaman
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PageErrorBoundary;
